import {createAsyncThunk} from '@reduxjs/toolkit';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';
import {campaignPlacementsApi} from 'common/src/modules/campaignPlacements/campaignPlacements.api';
import {updateCampaignPlacements} from '../campaignTree.slice';
import {Placement_UI} from 'common/src/modules/campaignPlacements/placements.types';

const fetchCampaignPlacements = createAsyncThunk<
  Placement_UI[],
  {
    campaignId: number;
    campaignVersionId: number;
  }
>('campaignTree/fetchCampaignPlacements', async ({campaignId, campaignVersionId}, {dispatch}) => {
  try {
    const campaignPlacements = await campaignPlacementsApi.getPlacements({
      campaignId,
      campaignVersionId,
    });

    dispatch(updateCampaignPlacements(campaignPlacements));

    return campaignPlacements;
  } catch (error) {
    handleApiError(error);
  }
});

export default fetchCampaignPlacements;
